






























import Vue from 'vue'
import { SearchRequest } from '@/core/api/search'
import PublicationCard from '@/components/publication-card.vue'

export default Vue.extend({
  components: {
    PublicationCard,
  },
  props: {
    'sourceId': {
      type: String,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
    item: null,
    items: [],
    meta: null as any,
    loading: false,
    pageSize: 20,
    page: 1,
    daysDepth: 30,
    headers: [
      {
        text: 'URL',
        value: 'url',
        width: '250px',
      },
      {
        text: 'Заголовок',
        align: 'start',
        value: 'title',
      },
      {
        text: 'Дата',
        value: 'publish_date',
        width: '150px',
      },
    ],
  }),
  computed: {
    pageCount(): number {
      if (this.meta) {
        return Math.min(Math.floor(this.meta.total_results / this.pageSize) + 1, 500)
      }
      return 1
    },
  },
  watch: {
    sourceId() {
      this.fetch()
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      if (this.sourceId == null) {
        return
      }

      this.loading = true
      try {
        const request = new SearchRequest()
        request
          .send({
            query: '*',
            dateStart: this.$moment().subtract(this.daysDepth, 'days'),
            dateEnd: this.$moment(),
            sourceId: this.sourceId,
            page: this.page,
            pageSize: this.pageSize,
            mlgSample: true,
          })
          .then(
            ({ data }) => {
              this.items = data.results
              this.meta = data.meta
            },
            () => {
              this.$toastError.fire({ title: 'Ошибка обработки запроса' })
            },
          )
          .finally(() => {
            this.loading = false
          })
      } catch (err) {
        this.$toastError.fire()
      }
      this.loading = false
    },
    onPageChange(page) {
      this.page = page
      this.fetch()
    },
    onItemClick(item) {
      this.item = item
      this.dialog = true
    },
  },
})
